








































































// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '../TokenUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { globalUC } from '../UserCache';
import { MomentOwned } from "@/MomentOwned";
import { Account } from "@/Account";

@Component({
  name: 'LinkAccountForm',
  components: { 
   }
})
export default class LinkAccountFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public usernameOrFlowAddress: string = null
  public account: Account = null
  public numMoments: number = null
  public accountFMV: number = null
  public lowestMoment: MomentOwned = null
  public saidOk: boolean = false
  public priceToList: number = null
  public startedVerifyPolling: boolean = false
  public verified: boolean = false
  public aborted: boolean = false
  
  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public clearFields() {
    this.usernameOrFlowAddress = null;
  }
  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
    this.aborted = true
  }
  public onOK() {
    this.$emit('close', true)
    this.clearFields()
  }  
  public onNo() {
    this.account = null
    this.clearFields()
    this.saidOk = false
  }
  public onYes() {
    this.saidOk = true
  }
  public onMomentClicked() {
    const url: string = this.lowestMoment.getTopShotLink(true)
    if (url) window.open(url, "_blank"); 
  }
  public async onVerify() {
    this.startedVerifyPolling = true
    this.$store.commit('setLoading', { loading: true });
    let failed: boolean = false
    while (!this.verified && !failed && this.usernameOrFlowAddress && !this.aborted) {
      // make GET call to server
      try {
        const url: string = utils.getURLprefix() + `/api/topshot/verifyAccount/${this.usernameOrFlowAddress.trim()}`

        const response: any = await utils.makeGetCall(url);
        if (!response || !response.data) throw(new Error('LinkAccountFormComponent.onVerify() got null response or null response.data'))
        if (response.data.error) {
          this.$store.commit('setLoading', { loading: false });
          utils.toast(this, 'Error', response.data.error)
          failed = true
          break
        }

        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one

        this.verified = Boolean(response.data.verified)

        if (this.verified) utils_tracker.track('User Linked Top Shot Account', { email: user.email, username: user._temp.account.username })

      } catch (error) {
        utils.toast(this, 'System Error', 'Could not verify account')
        if (this.$store.state.devmode) console.error(error);
        failed = true
        break
      }

      await utils.sleep(2000)
    }

    this.$store.commit('setLoading', { loading: false });
  }

  // Parents call this to show modal (use a ref to call child -- https://stackoverflow.com/questions/42632711/how-to-call-function-on-child-component-on-parent-events)
  public async onShow(dynamicProps: { usernameOrFlowAddress?: string  }) {
    if (!dynamicProps) return
    if (dynamicProps.usernameOrFlowAddress) {
      this.usernameOrFlowAddress = dynamicProps.usernameOrFlowAddress
    }
  }

  public async onLookup() {
    // tidy up form fields
    if (this.usernameOrFlowAddress) this.usernameOrFlowAddress = this.usernameOrFlowAddress.trim()

    // validate form fields
    let abort: boolean = false
    if (!this.usernameOrFlowAddress || this.usernameOrFlowAddress.trim().length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter a Top Shot username or Flow address.')
    }

    if (abort) return

    // make GET call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + `/api/topshot/linkAccount/${this.usernameOrFlowAddress.trim()}`

      const response: any = await utils.makeGetCall(url);
      if (!response || !response.data) throw(new Error('LinkAccountFormComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }

      if (response.data.account) {
        this.account = new Account(response.data.account)
        this.numMoments = Number(response.data.numMoments)
        this.accountFMV = Number(response.data.accountFMV)
        this.lowestMoment = new MomentOwned(response.data.lowestMoment)
        this.priceToList = Number(response.data.priceToList)
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not lookup account')
      if (this.$store.state.devmode) console.error(error);
    }

    this.$store.commit('setLoading', { loading: false });

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    utils_tracker.track('User ClickedLinkAccount', {})

  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
